const randomIPv6 = () => {
	const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('')
	return `${genRanHex(4)}${[...Array(7)].map(() => `:${genRanHex(4)}`).join('')}`
}

export default randomIPv6
